import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AcknowledgeComponent } from './acknowledge/acknowledge.component';
import { RouterModule } from '@angular/router';
import { routing } from './weblink.routing';
import { AppComponent } from '../app.component';
import { FormsModule } from '@angular/forms';
import { SharedModule } from '../shared/modules/shared.module';
import { WeblinkService } from '../weblink/services/weblink.service';


@NgModule({
  declarations: [AcknowledgeComponent],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule.forRoot(routing, {}),
    SharedModule
  ],  
  providers: [AppComponent, WeblinkService]
})
export class WeblinkModule { }
